import {ICodigoProducto} from '../interface/ICodigoProducto';

export class CodigoProducto implements ICodigoProducto {
  id: number;
  codigo: string;
  descripcion: string;
  descuento: number;
  valor: number;
  valorUsd: number;
  productoId: number;
  produtoNombre?: string;
  fecCreacion?: Date;
  fecModificacion?: Date;

  constructor(codigo: ICodigoProducto) {
    this.id = codigo.id;
    this.codigo = codigo.codigo;
    this.descripcion = codigo.descripcion;
    this.descuento = Number(codigo.descuento);
    this.valor = Number(codigo.valor);
    this.valorUsd = (codigo.valorUsd);
    this.productoId = codigo.productoId;
    this.produtoNombre = codigo.produtoNombre;
    this.fecCreacion = codigo.fecCreacion;
    this.fecModificacion = codigo.fecModificacion;
  }
}



// WEBPACK FOOTER //
// /app/src/model/class/CodigoProducto.ts